import DPDropDown from "framework/components/DPDropDown"
import DPSwitch from "framework/components/DPSwitch"
import React, { useState, useEffect } from "react"
import { CardText, Col, Row, Alert, Button, Label } from "reactstrap"
import DPTextBox from "../../../framework/components/DPTextBox"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/Supplier.xlsx"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "framework/validators/SearchColumn"

const VendorMasterTab1 = ({
  fieldManager,
  CodeValue,
  CodeonChange,
  CodeFind,
  disabledCode,
  NameValue,
  NameonChange,
  GroupValue,
  GrouponChange,
  CategoryValue,
  CategoryonChange,
  TypeValue,
  TypeonChange,
  LinkRefValue,
  LinkRefonChange,
  GLCodeValue,
  GLCodeonChange,
  StatusSw,
  SwonChange,
  disabled,
  BusRegValue,
  BusRegonChange,
  StDiscountValue,
  StDiscountonChange,
  StContValue,
  StContonChange,
  FileIDValue,
  FileIDonChange,
  show,
  AlertColor,
  AlertMsg,
  vender_CodeSearchOpen,
  vender_CodeSearchTrigger,
  vender_SelectRowSearch,
  StContonBlur,
  StDiscountonBlur,
  ErrorMsg,
  menuName,
  onButtonClick,
  btnDisable,
  SearchDisable,
  showFileUpload,
  valueUpload,
  menuCode,
  autoCode,
  setDefault_markup,
  default_markup,
  setDefault_markupOnblur,
  skipApproval,
  setSkipApproval
}) => {
  const [optionGroup, setoptionGroup] = useState([]);
  const [optiontype, setoptiontype] = useState([]);
  const [optionCategory, setoptionCategory] = useState([]);
  const [DataTables, SetDatatable] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')
  const ApiURL = window.Links.ApiURL

  const [SupplierColumns, setSupplierColumns] = useState([])

  useEffect(async () => {
    setSupplierColumns(await loadPopupSearchPay(menuCode, 'SUPPLIER'))
  }, [menuCode]);



  useEffect(() => {
    const authToken = localStorage.getItem("authToken")
    /***********get supplier Group************ */
    function getSupplierGroup() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}SupplierGroup/select`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setoptionGroup(result.data)
          let dt = result.data
        })
        .catch(error => console.log('error', error));
    }
    /***********get supplier Group end ************ */

    /***********get supplier Type************ */
    function getSupplierType() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}SupplierType/select`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setoptiontype(result.data)
          let dt = result.data
        })
        .catch(error => console.log('error', error));
    }
    /***********get supplier Type end************ */

    /***********get supplier Category************ */
    function getSupplierCategory() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}SupplierCategory/select`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setoptionCategory(result.data)
          let dt = result.data
        })
        .catch(error => console.log('error', error));
    }
    /***********get supplier Category end************ */

    getSupplierGroup()
    getSupplierType()
    getSupplierCategory()

  }, []);


  //****************Api call for search table***************
  async function tog_backdrop() {
    vender_CodeSearchTrigger();
  }



  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                  <br />
                  <small>{ErrorMsg}</small>
                </Alert>
              ) : null}
              <Row>
                <Col sm={12} md={6} className="mb-4-sm">

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_CODE')}>
                    <DPTextBoxButton
                      rowClass="mb-4-sm"
                      labelText="Code *"
                      textType="text"
                      maxLength="10"
                      value={CodeValue}
                      onChange={CodeonChange}
                      onBlur={CodeFind}
                      placeholder={autoCode}
                      disabled={disabled == true ? disabled : disabledCode || fieldManager.disable.includes('SM_CODE')}
                      onButtonClick={onButtonClick}
                      btnDisable={disabled == true ? disabled : btnDisable || fieldManager.disable.includes('SM_CODE')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_NAME')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Name *"
                      textType="text"
                      maxLength="40"
                      value={NameValue}
                      onChange={NameonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_NAME')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_GROUP')}>
                    <DPDropDown
                      labelText="Group *"
                      rowClass="mb-4-sm"
                      optionGroup={optionGroup}
                      selectedGroup={GroupValue}
                      onChange={GrouponChange}
                      disabled={disabled || fieldManager.disable.includes('SM_GROUP')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_CATE')}>
                    <DPDropDown
                      labelText="Category *"
                      rowClass="mb-4-sm"
                      optionGroup={optionCategory}
                      selectedGroup={CategoryValue}
                      onChange={CategoryonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_CATE')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_TYPE')}>
                    <DPDropDown
                      labelText="Type *"
                      rowClass="mb-4-sm"
                      optionGroup={optiontype}
                      selectedGroup={TypeValue}
                      onChange={TypeonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_TYPE')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_LINKREF')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Link Reference code"
                      textType="text"
                      maxLength="30"
                      value={LinkRefValue}
                      onChange={LinkRefonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_LINKREF')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_GLCODE')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="GL code"
                      textType="text"
                      maxLength="30"
                      value={GLCodeValue}
                      onChange={GLCodeonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_GLCODE')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_STATUS')}>
                    <Row>
                      <Col sm={3}>
                        <Label
                          htmlFor="example-text-input"
                          className={`col-md-12 col-form-label-sm`}
                        >
                          Status
                        </Label></Col>
                      <Col >
                        <DPSwitch
                          rowClass="mb-4-sm"
                          labelText="Status *"
                          textType="checkbox"
                          onChange={SwonChange}
                          checked={StatusSw}
                          disabled={disabled || fieldManager.disable.includes('SM_STATUS')}

                        />
                      </Col>
                    </Row>
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_BUSREG')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Business registration number"
                      textType="text"
                      value={BusRegValue}
                      onChange={BusRegonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_BUSREG')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_DISC')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Standard discount %"
                      textType="text"
                      defaultValue="0.0"
                      textAlign="right"
                      value={StDiscountValue}
                      onChange={StDiscountonChange}
                      onBlur={StDiscountonBlur}
                      disabled={disabled || fieldManager.disable.includes('SM_DISC')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_CONT')}>
                    <DPTextBox
                      className="form-check-input"
                      labelText="Standard contribution %"
                      textType="text"
                      defaultValue="0.0"
                      textAlign="right"
                      value={StContValue}
                      onChange={StContonChange}
                      onBlur={StContonBlur}
                      disabled={disabled || fieldManager.disable.includes('SM_CONT')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_FOLDERID')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="File/Folder ID"
                      textType="text"
                      value={FileIDValue}
                      onChange={FileIDonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_FOLDERID')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_DEF_MARKUP')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Default Markup %"
                      textType="text"
                      textAlign={"right"}
                      value={default_markup}
                      onChange={setDefault_markup}
                      onBlur={setDefault_markupOnblur}
                      disabled={disabled || fieldManager.disable.includes('SM_DEF_MARKUP')}
                    />
                  </div>
                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_SKIP_APPROVAL')}>
                    <Row>
                      <Col sm={3}>
                        <Label
                          htmlFor="example-text-input"
                          className={`col-md-12 col-form-label-sm`}
                        >
                          Skip Approval
                        </Label></Col>
                      <Col >
                        <DPSwitch
                          rowClass="mb-4-sm"
                          labelText="Status *"
                          textType="checkbox"
                          onChange={setSkipApproval}
                          checked={skipApproval}
                          disabled={disabled || fieldManager.disable.includes('SM_SKIP_APPROVAL')}

                        />
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col sm={12} md={5} className="mb-4-sm">
                  <Button
                    onClick={() => { tog_backdrop() }}
                    color="success"
                    className="btn-sm"
                    disabled={SearchDisable}
                  >
                    <i
                      className="mdi mdi-search-web"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </Button>
                </Col>

                <Col sm={12} md={1} className="mb-4-sm">
                  <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <input
                        id="file"
                        type="file"
                        onChange={showFileUpload}
                        value={valueUpload}
                        disabled={disabledCode}
                        accept=".xlsx, .xls, .csv"
                        style={{ display: "none" }}
                      />

                      <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                        <span >
                          <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                        </span>
                      </label></li>

                    <li className="import-export-button" style={{ display: "block" }}>
                      <a href={MasterUpload} download="Supplier Upload" data-tip title="Supplier Upload excel download"
                        style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                        <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                      </a></li>
                  </ul>
                </Col>
              </Row>


              <Col sm={12} md={8} className="mb-4-sm">
                <Row>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                  <DPSearchBoxDynamic
                    searchData={DataTables}
                    columns={SupplierColumns}
                    defaultSorted={defaultSorted}
                    mainTitle={menuName + " Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={vender_CodeSearchOpen}
                    toggle={vender_CodeSearchTrigger}
                    getSelect={vender_SelectRowSearch}
                    APIURL={ApiURL}
                    URLPath={"SUPPLIER"}
                    MenuCode={menuCode}
                    KeyVal={'SUP'}
                    searchBy={'SM_CODE'}
                    FilterStr={groupFilter}
                  />
                </Row>
              </Col>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default VendorMasterTab1
